import React, { useState, useRef, useEffect } from "react";
import genStyles from './generale.module.css';

export function DropdownSelect({ 
    options,           // [{ name, iconClass }]
    selected,          // valeur sélectionnée (iconClass)
    onChange, 
    type = "icon",     // "icon" ou "color"
    showCustomColor = false // pour ajouter bouton  en mode color
}) {
    const [open, setOpen] = useState(false);
    const containerRef = useRef();
    const colorInputRef = useRef();

    useEffect(() => {
        function handleClickOutside(event) {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div ref={containerRef} style={{ position: "relative", display: "inline-block" }}>
            {/* Bouton principal */}
            <button
                type="button"
                onClick={() => setOpen(!open)}
                style={{
                    width: 20,
                    height: 20,
                    border: "1px solid #ccc",
                    background: type === "color" ? selected : "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    padding: 0,
                }}
            >
                {type === "icon" && selected && <i className={selected} style={{ fontSize: 12 }} />}
            </button>

            {open && (
                <ul
                    style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        background: "white",
                        border: "1px solid #ccc",
                        padding: 4,
                        margin: 0,
                        listStyle: "none",
                        display: "grid",
                        gridTemplateColumns: "repeat(5, 20px)",
                        gap: 4,
                        maxHeight: 4 * 40 + 4 * 3,
                        overflowY: "auto",
                        zIndex: 9999,
                        boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
                    }}
                >
                    {options.map((opt) => (
                        <li
                            key={opt.name}
                            onClick={() => {
                                onChange(opt.name);
                                setOpen(false);
                            }}
                            style={{
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: 20,
                                height: 20,
                                borderRadius: 4,
                                border: type === "color" ? "1px solid #ccc" : "none",
                                background: type === "color" ? opt.iconClass : "transparent",
                            }}
                            title={opt.name}
                        >
                            {type === "icon" && <i className={opt.iconClass} style={{ fontSize: 12 }} />}
                        </li>
                    ))}

                    {/* Bouton pour autre couleur */}
                    {type === "color" && showCustomColor && (
                        <li
                            onClick={() => colorInputRef.current.click()}
                            style={{
                                width: 20,
                                height: 20,
                                background: "#fff",
                                cursor: "pointer",
                                borderRadius: 4,
                                border: "1px solid #ccc",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: 12,
                            }}
                            title="Choisir une autre couleur"
                        >
                           <i className="fa-solid fa-palette" aria-hidden="true" />
                        </li>
                    )}
                </ul>
            )}

            {/* Input color caché */}
            {type === "color" && showCustomColor && (
                <input
                    className={genStyles.inputtCol} 
                    type="color"
                    ref={colorInputRef}
                    style={{ display: "none" }}
                    onChange={(e) => {
                        onChange(e.target.value);
                        setOpen(false);
                    }}
                />
            )}
        </div>
    );
}
